import React, { useEffect, useState } from 'react';
import {Button, Modal, Switch } from 'antd';
import TemplateEdit from './components/template-edit';
import TemplateList from './components/template-list';
import './index.less';
import IF from '@/components/IF';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reduxjs/toolkit';

import {TemplateEnumType} from '@/util/Request/agrialert/responseType';
import { useLocation } from 'react-router-dom';
import { updateCurrentRoleId, updateCurrentUserId, updateSuccessOpen, updateTab, updateTemplateType, updateTempOrSubName } from
    '@/redux/reducer/agrialertTemplate';
import TemplatePreview from './components/template-preview';
import { AgrialertUserManagementSuccessSvg } from '@/resource/IconComponentSets';
import { updateCurrentSys } from '@/redux/reducer/common';
import { agriAlertGetAuthenticate, portalProceedModuleSelect } from '@/util/Request';

export const AgregationEnum = {
    DAILY: 'daily',
    EIGHTHOURLY: '8hourly',
    HOURLY: 'hourly'
};
export const ChartsOrTablesEnum = {
    CHARTS: 'Charts',
    TABLES: 'Tables'
};

export const SpeedUnitEnum = {
    BEAUFORT: 'Beaufort',
    KMH: 'km/h',
    MPH: 'mph'
};
export const HistoricalOrForecastEnum = {
    HISTORICAL: 'historical',
    FORECAST: 'forecast'
};
export const enum HeatOrColdStressRiskEnum {
    HEATSTRESSRISK = 'Heat Stress Risk',
    COLDSTRESSRISK = 'Cold Stress Risk'
}

export const ForecastDays = [
    1,2,3,4,5,6,7,8,9,10,11,12,13,14
];
export const DiseaseForecastDays = [
    1,2,3,4,5,6,7,8,9,10
];
export const HistoricalDays = [
    1,2,3,4,5,6,7
];

const TemplateManagement = ()=>{

    const dispatch = useDispatch();
    const location = useLocation();

    // get data from redux
    const currentUser = useSelector((state: RootState) => state.agrialertUser.userFirstName);
    const selectedTemplateType = useSelector((state: RootState) => state.agrialertTemplate.templateType);
    const successOpen = useSelector((state: RootState) => state.agrialertTemplate.successOpen);
    const tempOrSubName = useSelector((state: RootState) => state.agrialertTemplate.tempOrSubName);

    const getCurrentRole = async () => {
        const result = await portalProceedModuleSelect('agri alert');
        if (result === 'Success') {
            const authenticate = await agriAlertGetAuthenticate('agri alert');
            if (authenticate.userIsActive) {
                dispatch(updateCurrentSys('agrialert'));
                dispatch(updateCurrentUserId(authenticate.userId));
                dispatch(updateCurrentRoleId(authenticate.roleId));
                if ((authenticate.roleId === 1) || (authenticate.roleId === 4))
                    dispatch(updateTab(Number(1)));
                if (authenticate.roleId === 3)
                    dispatch(updateTab(Number(3)));
            }else {
                alert('You do not have access to the AgriAlert system, please contact the support team.');
            }
        }
    };

    useEffect(() => {
        getCurrentRole();
    }, []);

    useEffect(()=>{
        dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
    },[location.pathname]);

    const closeSuccessModal=()=>{
        dispatch(updateSuccessOpen(false));
    };
    return(
        <div className="template-management-container" style={{ width: '97%'}}>
            <div
                className="site-layout-background"
            >
                <IF show={selectedTemplateType === TemplateEnumType.LISTTEMPLATE}>
                    <TemplateList/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.CREATETEMPLATE}>
                    <TemplateEdit/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.EDITTEMPLATE}>
                    <TemplateEdit/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.VIEWTEMPLATE}>
                    <TemplateEdit/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.SUBSCRIBE}>
                    <TemplateEdit/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION}>
                    <TemplateEdit/>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE}>
                    <TemplateEdit/>
                </IF>

                <Modal
                    open={successOpen}
                    cancelText="Close"
                    width={608}
                    closable={false}
                    className='success-modal'
                    style={{padding:'50px 0'}}
                    footer={
                        <div>
                            <Button type="default" onClick={closeSuccessModal}>
                            Close
                            </Button>
                        </div>
                    }
                >
                    <AgrialertUserManagementSuccessSvg />
                    <p className='second-line-style'>&apos;{tempOrSubName}&apos;<br />
                        <span className='first-line-style'>Saved Successfully</span></p>
                </Modal>
            </div>
        </div>
    );
};

export default TemplateManagement;